import React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { genRandomString } from '../utils/helpers';

const InfoTooltipWrapper = styled.span`
  margin-left: 8px;
  color: #999;
  font-size: 0.9em;
`;

const InfoTooltip = ({ tooltip }) => {
  const randomTooltipId = genRandomString(15);
  return (
    <InfoTooltipWrapper
      data-tip
      data-for={randomTooltipId}
      data-html={true}
      data-multiline={true}>
      <ReactTooltip id={randomTooltipId}>{tooltip}</ReactTooltip>
      <i className='fas fa-info-circle'></i>
    </InfoTooltipWrapper>
  );
};

export default InfoTooltip;
